import { NgxPrintModule } from "ngx-print";
import { FormlyBootstrapModule } from "@ngx-formly/bootstrap";
import { AngularMaterialModule } from "@cradua/material";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormlyModule } from "@ngx-formly/core";
import { StepperDynamicFormComponent } from "./components/stepper-dynamic-form/stepper-dynamic-form.component";
import { InputComponent } from "./components/input/input.component";
import { ButtonComponent } from "./components/button/button.component";
import { SelectComponent } from "./components/select/select.component";
import { DateComponent } from "./components/date/date.component";
import { RadiobuttonComponent } from "./components/radiobutton/radiobutton.component";
import { CheckboxComponent } from "./components/checkbox/checkbox.component";
import { DynamicFieldDirective } from "./components/dynamic-field/dynamic-field.directive";
import { SearchInputComponent } from "./components/search-input/search-input.component";
import { DynamicFormComponent } from "./components/dynamic-form/dynamic-form.component";
import { DynamicFlatFieldDirective } from "./components/dynamic-field/dynamic-flat-field.directive";
import { AutocompleteComponent } from "./autocomplete/autocomplete.component";
import { FilterPipe } from "./filter.pipe";
import { AutocompleteDirective } from "./autocomplete/autocomplete.directive";
import { AutocompleteContentDirective } from "./autocomplete/autocomplete-content.directive";
import { OptionComponent } from "./autocomplete/option/option.component";
import { CountryViewComponent } from "./components/country-view/country-view.component";
import { ReferenceFormViewComponent } from "./container/reference-form-view/reference-form-view.component";
import { ReferenceFormDirective } from "./directives/reference-form.directive";
import { StateViewComponent } from "./components/state-view/state-view.component";
import { LgaViewComponent } from "./components/lga-view/lga-view.component";
import { CourseofstudyViewComponent } from "./components/courseofstudy-view/courseofstudy-view.component";
import { ScholarshipCategoryViewComponent } from "./components/scholarship-category-view/scholarship-category-view.component";
import { ScholarshipSessionViewComponent } from "./components/scholarship-session-view/scholarship-session-view.component";
import { ScholarshipDurationViewComponent } from "./components/scholarship-duration-view/scholarship-duration-view.component";
import { CommunityViewComponent } from "./components/community-view/community-view.component";
import { ScholarshipTypeViewComponent } from "./components/scholarship-type-view/scholarship-type-view.component";
import { GenderViewComponent } from "./components/gender-view/gender-view.component";
import { ModalActionsService } from "./services/modal-actions.service";
import { ModalComponent } from "./components/modal/modal.component";
import { BankViewComponent } from "./components/bank-view/bank-view.component";
import { BankDetailViewComponent } from "./components/bank-detail-view/bank-detail-view.component";
import { CurrencyViewComponent } from "./components/currency-view/currency-view.component";
import { ProjectReferenceFormViewComponent } from "./container/project-reference-form-view/project-reference-form-view.component";
import { ProjectCategoryViewComponent } from "./components/project-category-view/project-category-view.component";
import { ProjectTypeViewComponent } from "./components/project-type-view/project-type-view.component";
import { ClusterViewComponent } from "./components/cluster-view/cluster-view.component";
import { ClusterCommunityViewComponent } from "./components/cluster-community-view/cluster-community-view.component";
import { OilBlockViewComponent } from "./components/oil-block-view/oil-block-view.component";
import { OilFieldViewComponent } from "./components/oil-field-view/oil-field-view.component";
import { DocumentCategoryViewComponent } from "./components/document-category-view/document-category-view.component";
import { DocumentSubCategoryViewComponent } from "./components/document-sub-category-view/document-sub-category-view.component";
import { ProjectReferenceFormDirective } from "./directives/project-reference-form.directive";
import { ProjectModalComponent } from "./components/project-modal/project-modal.component";
import { ActivityModalComponent } from "./components/activity-modal/activity-modal.component";
import { CorrespondenceFormContainerComponent } from "./container/correspondence-form-container/correspondence-form-container.component";
import { ActionPartyViewComponent } from "./components/action-party-view/action-party-view.component";
import { CompanyViewComponent } from "./components/company-view/company-view.component";
import { FunctionViewComponent } from "./components/function-view/function-view.component";
import { TeamViewComponent } from "./components/team-view/team-view.component";
import { RequestCategoryViewComponent } from "./components/request-category-view/request-category-view.component";
import { IssuedCategoryViewComponent } from "./components/issued-category-view/issued-category-view.component";
import { CorrespondenceFormDirective } from "./directives/correspondence-form.directive";
import { CorrespondenceModalComponent } from "./components/correspondence-modal/correspondence-modal.component";
import { CdkStepperModule } from "@angular/cdk/stepper";

const publicApi = [
  AutocompleteComponent,
  AutocompleteDirective,
  AutocompleteContentDirective,
  OptionComponent,
];

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AngularMaterialModule,
    NgxPrintModule,
    CdkStepperModule,
    // AutocompleteModule,
    FormlyModule.forRoot({
      validationMessages: [
        { name: "required", message: "This field is required" },
      ],
    }),
    FormlyBootstrapModule,
    // FormlyMaterialModule
  ],
  declarations: [
    SearchInputComponent,
    StepperDynamicFormComponent,
    InputComponent,
    ...publicApi,
    ButtonComponent,
    SelectComponent,
    DateComponent,
    RadiobuttonComponent,
    CheckboxComponent,
    DynamicFieldDirective,
    ReferenceFormDirective,
    ProjectReferenceFormDirective,
    CorrespondenceFormDirective,
    DynamicFormComponent,
    FilterPipe,
    DynamicFlatFieldDirective,
    CountryViewComponent,
    ReferenceFormViewComponent,
    StateViewComponent,
    LgaViewComponent,
    CourseofstudyViewComponent,
    ScholarshipCategoryViewComponent,
    ScholarshipSessionViewComponent,
    ScholarshipDurationViewComponent,
    CommunityViewComponent,
    ScholarshipTypeViewComponent,
    GenderViewComponent,
    ModalComponent,
    BankViewComponent,
    BankDetailViewComponent,
    CurrencyViewComponent,
    ProjectReferenceFormViewComponent,
    ProjectCategoryViewComponent,
    ProjectTypeViewComponent,
    ClusterViewComponent,
    ClusterCommunityViewComponent,
    OilBlockViewComponent,
    OilFieldViewComponent,
    DocumentCategoryViewComponent,
    DocumentSubCategoryViewComponent,
    ProjectModalComponent,
    ActivityModalComponent,
    CorrespondenceFormContainerComponent,
    ActionPartyViewComponent,
    CompanyViewComponent,
    FunctionViewComponent,
    TeamViewComponent,
    RequestCategoryViewComponent,
    IssuedCategoryViewComponent,
    CorrespondenceModalComponent,
    // MyStepperComponent,
  ],
  exports: [
    SearchInputComponent,
    ...publicApi,
    FilterPipe,
    StepperDynamicFormComponent,
    DynamicFormComponent,
    // AutocompleteComponent,
    ReferenceFormViewComponent,
    ProjectReferenceFormViewComponent,
    CorrespondenceFormContainerComponent,
    // MyStepperComponent,
  ],

  providers: [ModalActionsService],
  entryComponents: [
    InputComponent,
    ButtonComponent,
    SelectComponent,
    DateComponent,
    RadiobuttonComponent,
    CheckboxComponent,
    CountryViewComponent,
    StateViewComponent,
    LgaViewComponent,
    CourseofstudyViewComponent,
    ScholarshipCategoryViewComponent,
    ScholarshipSessionViewComponent,
    ScholarshipDurationViewComponent,
    CommunityViewComponent,
    ScholarshipTypeViewComponent,
    GenderViewComponent,
    ModalComponent,
    ProjectModalComponent,
    BankViewComponent,
    BankDetailViewComponent,
    CurrencyViewComponent,
    ProjectCategoryViewComponent,
    ProjectTypeViewComponent,
    ClusterViewComponent,
    ClusterCommunityViewComponent,
    OilBlockViewComponent,
    OilFieldViewComponent,
    DocumentCategoryViewComponent,
    DocumentSubCategoryViewComponent,
    ActivityModalComponent,
    ActionPartyViewComponent,
    CompanyViewComponent,
    FunctionViewComponent,
    TeamViewComponent,
    RequestCategoryViewComponent,
    IssuedCategoryViewComponent,
    CorrespondenceModalComponent,
  ],
})
export class SharedModule {}
